module.exports = __webpack_public_path__ + "static/media/www.komediateatteri.fi.12f096d0.png";